import { Dialog, DialogTitle, DialogContent, IconButton, Grid, Card, CardContent } from "@material-ui/core";
import * as React from 'react';
import CloseIcon from '@material-ui/icons/Close';
import * as moment from 'moment';

export default class ReviewCommentComponent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            allData: {},
            showDialog: false,
            fullWidth: true,
            maxWidth: 'sm',
            classType: '',
            validationError: false,
            comments: this.props.comments
        }

        this.handleClose = this.handleClose.bind(this);
    }

    renderQuestionComments() {
        const elements: any = [];
        if (this.state.comments && this.state.comments.length > 0) {
            this.state.comments.forEach((comment: any, index: number) => {
                const localTime = moment.utc(comment.commented_date).toDate();
                const localTimeFormatted = moment(localTime).format('DD-MM-YYYY hh:mm:ss a');
                elements.push(
                    <Card key={index + 'Card'} className={comment.commented_by_role && comment.commented_by_role === 'HQ Admin' ? "commentsBoxRed" : "commentsBoxRegional"}>
                        <CardContent key={index + 'CardContent'}>
                            <div className="card card-default" key={index + 'card card-default'}>
                                <div className="card-body" key={index + 'card-body'}>
                                    <div className="addCommentAction alignWrapper" key={index + 'alignWrapper'}>
                                        <div className="alignLeft" key={index + 'alignLeft'}>
                                            <div key={index + 'devLeft'} className="comment-user">{comment ? `${comment.commented_by_name}(${comment.commented_by_role}) | ${comment.commented_by_email}` : ''}</div>
                                        </div>
                                    </div>
                                    <div className="comment-post" key={index + 'comment-post'}>
                                        <span key={index + 'span'}>
                                            {comment && comment.comment_text ? comment.comment_text : ''}
                                        </span>
                                    </div>
                                    <div className="text-right" key={index + 'right'}>
                                        <span key={index + 'spandate'} className="comment-date"> {comment ? localTimeFormatted : ''}</span>
                                    </div>
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                );
            });
        }

        return elements;
    }

    handleClose() {
        this.props.onDialogClose(true);
    }

    render() {
        return (
            <>
                {
                    <Dialog
                        fullWidth={this.state.fullWidth}
                        hideBackdrop={true}
                        maxWidth={this.state.maxWidth}
                        open={this.props.showCommentsDialog}
                        aria-labelledby="max-width-dialog-title"
                        className="applicationDialog"
                    >
                        <div className="dialogWrapper">
                            <div className="dialogHead">
                                <DialogTitle id="max-width-dialog-title" className="dialogTitle">All Comments
                                 <IconButton aria-label="Close" className="closeButton" onClick={this.handleClose}>
                                        <CloseIcon />
                                    </IconButton>
                                    <hr className="HZDivider" />
                                </DialogTitle>
                            </div>
                            <div className="dialogContent">
                                <DialogContent>
                                    <Grid container={true} spacing={8}>
                                        <Grid item={true} xs={12}>
                                            {this.state.comments.length > 0 ? this.renderQuestionComments() : 'Comments are not available'}
                                        </Grid>
                                    </Grid>
                                </DialogContent>
                            </div>
                        </div>
                    </Dialog>
                }
            </>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/reviewquetions/ReviewCommentComponent.tsx